/**
 * Floating Story Video Component
 * Handles Instagram Stories-style video modal with swipe navigation
 */

document.addEventListener('DOMContentLoaded', function() {
  console.log('Floating Story Video: DOM loaded');

  // Get section ID from script tag
  const scriptTag = document.querySelector('script[data-section-id]');
  const sectionId = scriptTag ? scriptTag.dataset.sectionId : '';
  console.log('Section ID:', sectionId);

  // Selectors with section ID
  const floatingButton = document.getElementById(`floating-story-button-${sectionId}`);
  const overlay = document.getElementById(`story-overlay-${sectionId}`);
  const videoDataContainer = document.getElementById(`story-videos-data-${sectionId}`);

  if (!floatingButton || !overlay || !videoDataContainer) {
    console.error('Floating Story Video: Required elements not found');
    return;
  }

  const trigger = floatingButton.querySelector('.floating-story-button__trigger');
  const closeBtn = overlay.querySelector('.story-overlay__close');
  const muteToggle = overlay.querySelector('.story-overlay__mute-toggle');
  const overlayThumbnails = overlay.querySelector('.story-overlay__thumbnails');
  const overlayPrevBtn = overlay.querySelector('.story-overlay__nav--prev');
  const overlayNextBtn = overlay.querySelector('.story-overlay__nav--next');
  const videoContainerWrapper = overlay.querySelector('.story-overlay__video-wrapper');
  const prevContainer = videoContainerWrapper.querySelector('.story-overlay__video--prev');
  const currentContainer = videoContainerWrapper.querySelector('.story-overlay__video--current');
  const nextContainer = videoContainerWrapper.querySelector('.story-overlay__video--next');
  const scrollIndicator = overlay.querySelector('.story-overlay__scroll-indicator');

  console.log('Selectors initialized');

  // Variables
  let currentVideoIndex = 0;
  let isPlaying = true;
  let currentVideoElement = null;
  let playButtonOverlay = null;
  let isMuted = true;
  let startY, currentY, isDragging = false;
  let dragStartTime;
  const dragThreshold = 10;
  const tapThreshold = 200;
  const slideThreshold = 50;
  const minDragVelocity = 0.5;
  let lastToggleTime = 0;
  const toggleDebounceTime = 300;
  let scrollIndicatorTimeout;

  // Get all video templates from hidden container
  const videoTemplates = Array.from(videoDataContainer.querySelectorAll('video'));
  console.log('Found video templates:', videoTemplates.length);

  /**
   * Populates overlay preview thumbnails with video clones
   */
  function populateOverlayPreviews() {
    console.log('Populating overlay previews');
    const overlayPreviews = overlayThumbnails.querySelectorAll('.story-overlay__preview');

    videoTemplates.forEach((video, index) => {
      const overlayPreview = overlayPreviews[index];

      if (video && overlayPreview) {
        const clonedVideo = video.cloneNode(true);
        clonedVideo.muted = true;
        clonedVideo.loop = true;
        clonedVideo.playsInline = true;
        clonedVideo.controls = false;
        clonedVideo.autoplay = false;
        overlayPreview.appendChild(clonedVideo);

        // Store video index on preview element
        overlayPreview.dataset.videoIndex = index;
      }
    });
    console.log('Overlay previews populated');
  }

  /**
   * Updates thumbnail scroll position and visibility
   */
  function updateThumbnailScroll() {
    console.log('Updating thumbnail scroll');
    const previewItems = Array.from(overlayThumbnails.querySelectorAll('.story-overlay__preview'));
    const containerHeight = overlayThumbnails.offsetHeight;
    const totalThumbs = previewItems.length;

    if (totalThumbs === 0) return;

    let centerIndex;
    if (currentVideoIndex === 0) {
      centerIndex = 1;
    } else if (currentVideoIndex >= totalThumbs - 1) {
      centerIndex = totalThumbs - 2;
    } else {
      centerIndex = currentVideoIndex;
    }

    const thumbHeight = previewItems[0].offsetHeight;
    const centerPosition = containerHeight / 2 - thumbHeight / 2;

    previewItems.forEach((item, index) => {
      const offset = (index - centerIndex) * (thumbHeight + 10);
      item.style.transform = `translateY(${centerPosition + offset}px)`;

      const isVisible = Math.abs(index - centerIndex) <= 1;
      item.classList.toggle('visible', isVisible);
      item.classList.toggle('active', index === currentVideoIndex);

      const previewVideo = item.querySelector('video');
      if (previewVideo) {
        if (isVisible) {
          previewVideo.play().catch(e => console.log('Preview video play failed:', e));
        } else {
          previewVideo.pause();
        }
      }
    });
    console.log('Thumbnail scroll updated');
  }

  /**
   * Updates overlay navigation buttons state
   */
  function updateOverlayNavButtons() {
    if (overlayPrevBtn) {
      overlayPrevBtn.disabled = currentVideoIndex === 0;
    }
    if (overlayNextBtn) {
      overlayNextBtn.disabled = currentVideoIndex === videoTemplates.length - 1;
    }
  }

  /**
   * Updates mute button icon state
   */
  function updateMuteButtonState() {
    console.log('Updating mute button state');
    const mutedIcon = muteToggle.querySelector('.muted');
    const unmutedIcon = muteToggle.querySelector('.unmuted');
    if (isMuted) {
      mutedIcon.style.display = 'block';
      unmutedIcon.style.display = 'none';
    } else {
      mutedIcon.style.display = 'none';
      unmutedIcon.style.display = 'block';
    }
    console.log('Mute button state updated');
  }

  /**
   * Updates the main overlay video display
   */
  function updateOverlayVideo(index) {
    console.log('Updating overlay video for index:', index);
    currentVideoIndex = index;

    // Clear existing videos
    prevContainer.innerHTML = '';
    currentContainer.innerHTML = '';
    nextContainer.innerHTML = '';

    // Clone and setup current video
    const overlayVideo = videoTemplates[index].cloneNode(true);
    overlayVideo.muted = isMuted;
    overlayVideo.controls = false;
    overlayVideo.autoplay = true;
    overlayVideo.loop = true;
    overlayVideo.playsInline = true;
    overlayVideo.classList.add('story-overlay__video');

    currentContainer.appendChild(overlayVideo);

    // Create play button overlay
    playButtonOverlay = document.createElement('div');
    playButtonOverlay.className = 'story-overlay__play-button';
    playButtonOverlay.innerHTML = `
      <svg width="128" height="128" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" fill="rgba(0,0,0,0.5)"/>
        <path d="M20 16L32 24L20 32V16Z" fill="white"/>
      </svg>
    `;
    playButtonOverlay.style.display = 'none';
    currentContainer.appendChild(playButtonOverlay);

    // Load adjacent videos
    if (index > 0) {
      const prevVideo = videoTemplates[index - 1].cloneNode(true);
      prevVideo.muted = true;
      prevContainer.appendChild(prevVideo);
    }
    if (index < videoTemplates.length - 1) {
      const nextVideo = videoTemplates[index + 1].cloneNode(true);
      nextVideo.muted = true;
      nextContainer.appendChild(nextVideo);
    }

    // Update UI
    updateThumbnailScroll();
    updateOverlayNavButtons();
    updateMuteButtonState();

    // Attach event listeners to video
    overlayVideo.addEventListener('click', togglePlayPause);
    playButtonOverlay.addEventListener('click', togglePlayPause);

    currentVideoElement = overlayVideo;
    isPlaying = true;
    console.log('Overlay video updated');
  }

  /**
   * Toggles video play/pause state
   */
  function togglePlayPause(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    const now = new Date().getTime();
    if (now - lastToggleTime < toggleDebounceTime) {
      console.log('Ignoring rapid toggle');
      return;
    }
    lastToggleTime = now;

    console.log('togglePlayPause called');
    if (isPlaying) {
      currentVideoElement.pause();
      playButtonOverlay.style.display = 'block';
    } else {
      currentVideoElement.play();
      playButtonOverlay.style.display = 'none';
    }
    isPlaying = !isPlaying;
    console.log('Video playing state:', isPlaying);
  }

  /**
   * Shows scroll indicator on mobile
   */
  function showScrollIndicator() {
    if (window.innerWidth < 750 && scrollIndicator) {
      scrollIndicator.style.opacity = '1';
      scrollIndicator.dataset.enabled = 'true';
      clearTimeout(scrollIndicatorTimeout);
      scrollIndicatorTimeout = setTimeout(() => {
        scrollIndicator.style.opacity = '0';
        scrollIndicator.dataset.enabled = 'false';
      }, 2500);
    }
  }

  /**
   * Opens the overlay modal
   */
  function openOverlay() {
    console.log('Opening overlay');
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    currentVideoIndex = 0;
    updateOverlayVideo(0);
    showScrollIndicator();
  }

  /**
   * Closes the overlay modal
   */
  function closeOverlay() {
    console.log('Closing overlay');
    overlay.style.display = 'none';
    prevContainer.innerHTML = '';
    currentContainer.innerHTML = '';
    nextContainer.innerHTML = '';
    document.body.style.overflow = '';
  }

  /**
   * Slides to next/previous video with animation
   */
  function slideVideo(direction, startOffset = 0) {
    console.log('slideVideo called with direction:', direction, 'startOffset:', startOffset);
    const newIndex = currentVideoIndex + direction;
    console.log('New index:', newIndex);

    if (newIndex >= 0 && newIndex < videoTemplates.length) {
      const currentVideo = currentContainer.querySelector('video');
      const targetContainer = direction > 0 ? nextContainer : prevContainer;
      const targetVideo = targetContainer.querySelector('video');

      if (currentVideo && targetVideo) {
        console.log('Sliding video...');
        currentVideo.pause();
        targetVideo.currentTime = 0;
        targetVideo.play();

        currentContainer.classList.remove('transitioning');
        targetContainer.classList.remove('transitioning');

        const containerHeight = currentContainer.offsetHeight;
        const remainingOffset = direction * containerHeight - startOffset;

        currentContainer.style.transform = `translateY(${startOffset}px)`;
        targetContainer.style.transform = `translateY(${direction < 0 ? startOffset - containerHeight : startOffset + containerHeight}px)`;
        targetContainer.style.opacity = '1';

        void currentContainer.offsetWidth;

        const baseDuration = 300;
        const duration = Math.max(100, baseDuration * (Math.abs(remainingOffset) / containerHeight));

        currentContainer.style.transitionDuration = `${duration}ms`;
        targetContainer.style.transitionDuration = `${duration}ms`;

        currentContainer.classList.add('transitioning');
        targetContainer.classList.add('transitioning');

        currentContainer.style.transform = `translateY(${-direction * containerHeight}px)`;
        targetContainer.style.transform = 'translateY(0)';

        setTimeout(() => {
          console.log('Updating overlay video after slide');
          updateOverlayVideo(newIndex);
          currentContainer.classList.remove('transitioning');
          targetContainer.classList.remove('transitioning');
          currentContainer.style.transform = 'translateY(0)';
          prevContainer.style.transform = 'translateY(-100%)';
          nextContainer.style.transform = 'translateY(100%)';
          prevContainer.style.opacity = '0';
          nextContainer.style.opacity = '0';

          currentContainer.style.transitionDuration = '';
          targetContainer.style.transitionDuration = '';
        }, duration);
      } else {
        console.log('Current or target video not found');
      }
    } else {
      console.log('New index out of bounds');
    }
  }

  /**
   * Resets video position after failed drag
   */
  function resetVideoPosition() {
    console.log('Resetting video position');
    currentContainer.classList.add('transitioning');
    prevContainer.classList.add('transitioning');
    nextContainer.classList.add('transitioning');

    currentContainer.style.transform = 'translateY(0)';
    prevContainer.style.transform = 'translateY(-100%)';
    nextContainer.style.transform = 'translateY(100%)';
    prevContainer.style.opacity = '0';
    nextContainer.style.opacity = '0';

    setTimeout(() => {
      currentContainer.classList.remove('transitioning');
      prevContainer.classList.remove('transitioning');
      nextContainer.classList.remove('transitioning');
    }, 300);
  }

  /**
   * Handles drag start event
   */
  function handleDragStart(e) {
    console.log('Drag start event triggered');
    e.preventDefault();
    startY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
    currentY = startY;
    isDragging = false;
    dragStartTime = new Date().getTime();
    console.log('Start position:', startY);
  }

  /**
   * Handles drag move event
   */
  function handleDragMove(e) {
    if (startY === undefined) return;

    console.log('Drag move event triggered');
    currentY = e.type.includes('mouse') ? e.clientY : e.touches[0].clientY;
    const diffY = currentY - startY;
    console.log('Current position:', currentY, 'diff:', diffY);

    if (!isDragging && Math.abs(diffY) > dragThreshold) {
      isDragging = true;
      console.log('Drag threshold met, starting drag');
    }

    if (isDragging) {
      e.preventDefault();
      console.log('Dragging video');
      currentContainer.style.transform = `translateY(${diffY}px)`;
      if (diffY > 0 && currentVideoIndex > 0) {
        console.log('Dragging up, showing previous video');
        prevContainer.style.transform = `translateY(${diffY - prevContainer.offsetHeight}px)`;
        prevContainer.style.opacity = '1';
      } else if (diffY < 0 && currentVideoIndex < videoTemplates.length - 1) {
        console.log('Dragging down, showing next video');
        nextContainer.style.transform = `translateY(${diffY + nextContainer.offsetHeight}px)`;
        nextContainer.style.opacity = '1';
      }
    }
  }

  /**
   * Handles drag end event
   */
  function handleDragEnd(e) {
    console.log('Drag end event triggered');
    if (startY === undefined) return;

    const endY = e.type.includes('mouse') ? e.clientY : (e.changedTouches ? e.changedTouches[0].clientY : currentY);
    const diffY = endY - startY;
    const dragDuration = new Date().getTime() - dragStartTime;
    const dragVelocity = Math.abs(diffY) / dragDuration;
    console.log('Final drag distance:', diffY, 'Duration:', dragDuration, 'Velocity:', dragVelocity.toFixed(3), 'px/ms');

    if (Math.abs(diffY) > slideThreshold || dragVelocity > minDragVelocity) {
      console.log('Significant drag detected, sliding video');
      if (diffY > 0 && currentVideoIndex > 0) {
        console.log('Sliding to previous video');
        slideVideo(-1, diffY);
      } else if (diffY < 0 && currentVideoIndex < videoTemplates.length - 1) {
        console.log('Sliding to next video');
        slideVideo(1, diffY);
      } else {
        console.log('Cannot slide, resetting position');
        resetVideoPosition();
      }
    } else if (Math.abs(diffY) < dragThreshold && dragDuration < tapThreshold) {
      console.log('Tap detected, toggling play/pause');
      togglePlayPause(e);
    } else {
      console.log('Short drag or long press detected, resetting position');
      resetVideoPosition();
    }

    startY = undefined;
    currentY = undefined;
    isDragging = false;
  }

  // Initialize
  populateOverlayPreviews();

  // Event Listeners - Floating Button
  if (trigger) {
    trigger.addEventListener('click', openOverlay);
  }

  // Event Listeners - Close Button
  if (closeBtn) {
    closeBtn.addEventListener('click', closeOverlay);
  }

  // Event Listeners - Overlay click outside
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) {
      closeOverlay();
    }
  });

  // Event Listeners - ESC key
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && overlay.style.display === 'flex') {
      closeOverlay();
    }
  });

  // Event Listeners - Navigation Buttons
  if (overlayNextBtn) {
    overlayNextBtn.addEventListener('click', () => {
      console.log('Next button clicked');
      if (currentVideoIndex < videoTemplates.length - 1) {
        slideVideo(1);
      } else {
        console.log('Already at last video');
      }
    });
  }

  if (overlayPrevBtn) {
    overlayPrevBtn.addEventListener('click', () => {
      console.log('Previous button clicked');
      if (currentVideoIndex > 0) {
        slideVideo(-1);
      } else {
        console.log('Already at first video');
      }
    });
  }

  // Event Listeners - Mute Toggle
  if (muteToggle) {
    muteToggle.addEventListener('click', () => {
      console.log('Mute toggle clicked');
      if (currentVideoElement) {
        isMuted = !isMuted;
        currentVideoElement.muted = isMuted;
        updateMuteButtonState();
      }
    });
  }

  // Event Listeners - Thumbnail Click
  if (overlayThumbnails) {
    overlayThumbnails.addEventListener('click', (event) => {
      console.log('Overlay thumbnail clicked');
      const preview = event.target.closest('.story-overlay__preview');
      if (preview) {
        const clickedIndex = parseInt(preview.dataset.videoIndex, 10);
        console.log('Clicked thumbnail index:', clickedIndex);
        const direction = clickedIndex - currentVideoIndex;
        if (direction !== 0) {
          slideVideo(direction > 0 ? 1 : -1);
        }
      }
    });
  }

  // Event Listeners - Drag/Swipe on Video
  videoContainerWrapper.addEventListener('mousedown', (e) => {
    handleDragStart(e);
    document.addEventListener('mousemove', handleDragMove);
    document.addEventListener('mouseup', handleDragEnd);
  });

  videoContainerWrapper.addEventListener('touchstart', (e) => {
    handleDragStart(e);
    document.addEventListener('touchmove', handleDragMove, { passive: false });
    document.addEventListener('touchend', handleDragEnd);
  }, { passive: false });

  videoContainerWrapper.addEventListener('touchmove', (e) => e.preventDefault(), { passive: false });

  // Event Listeners - Scroll Indicator Touch
  if (scrollIndicator) {
    videoContainerWrapper.addEventListener('touchstart', () => {
      if (scrollIndicator.dataset.enabled === 'true') {
        scrollIndicator.style.opacity = '0';
        clearTimeout(scrollIndicatorTimeout);
      }
    }, { passive: true });
  }

  // Event Listeners - Window Resize
  window.addEventListener('resize', () => {
    console.log('Window resized');
    if (overlay.style.display === 'flex') {
      if (currentVideoElement) {
        currentVideoElement.style.maxWidth = '100%';
        currentVideoElement.style.maxHeight = '100%';
      }
    }
  });

  console.log('Floating Story Video: All event listeners attached');
});
